<ng-container
  *ngIf="icon">
  <ng-lottie
    [options]="options"
    (animationCreated)="created($event)"></ng-lottie>
</ng-container>